export default {"src":"/_next/static/media/website.f6239f4d.svg","height":42,"width":42,"blurWidth":0,"blurHeight":0};